import React from "react";
import BoardCardShell from "../BoardCardShell";
import TeamWidgetCard from "features/analytics/studio/components/home/teamWidgets/TeamWidgetCard";

/**
 * Team widget board card — wraps existing TeamWidgetCard in the unified shell.
 */
export default function TeamWidgetBoardCard({ card, result, onDelete, readOnly }) {
  const actions = readOnly ? [] : [
    ...(onDelete ? [{ label: "Delete", icon: "delete", onClick: onDelete, danger: true }] : []),
  ];

  return (
    <BoardCardShell
      title={card?.title || "Team widget"}
      actions={actions}
      readOnly={readOnly}
    >
      <div className="flex-1 min-h-0 overflow-auto">
        <TeamWidgetCard card={card} result={result} />
      </div>
    </BoardCardShell>
  );
}
